import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { SANDRE } from '../../../../../referencial/constants/ReferencialConstants'
import { getSandreLabel } from '../../../../../utils/StringUtil'
import DtoInstallation from '../../../../dto/installation/DtoInstallation'
import StationDescriptionTable from 'station/components/link/StationDescriptionTable'
import SimpleTextArea from 'components/forms/SimpleTextArea'
import { Card, CardContent, Grid } from '@mui/material'
import NumberField from 'components/forms/NumberField'
import Select from 'components/forms/Select'
import useSandreList from 'utils/customHook/useSandreList'

const headers = ['lithology', 'order', 'thickness', 'comment']

const LithologyDialogContent = ({
    stateElement,
    onChangeElement = () => { },
}) => {
    const lithologyList = useSandreList(SANDRE.LITHOLOGY)

    return (
        <Card>
            <CardContent>
                <Grid container columnSpacing={1}>
                    <Grid size={6}>
                        <Select
                            options={lithologyList}
                            label={i18n.name}
                            value={stateElement.lithologyCode}
                            onChange={v => onChangeElement({ lithologyCode: v })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            value={stateElement.thickness}
                            title={i18n.thickness}
                            onChange={v => onChangeElement({ thickness: v })}
                            floatValue
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.order}
                            value={stateElement.order}
                            onChange={v => onChangeElement({ order: v })}
                        />
                    </Grid>
                    <Grid size={12}>
                        <SimpleTextArea
                            value={stateElement.comment}
                            title={i18n.comment}
                            onChange={v => onChangeElement({ comment: v })}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

LithologyDialogContent.propTypes = {
    stateElement: PropTypes.object,
    onChangeElement: PropTypes.func,
}


const BoreholeLithologyTable = ({
    station = {},
    readMode = false,
    onChange = () => { },
}) => {
    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    return (
        <StationDescriptionTable
            station={station}
            readMode={readMode}
            onChange={onChange}
            keyList='link_lithology'
            formatFunction={c => ({
                ...c,
                type: getSandreLabel(sandreCodes, SANDRE.LITHOLOGY_TYPE, c.type),
                lithology: getSandreLabel(sandreCodes, SANDRE.LITHOLOGY, c.lithologyCode),
            })}
            titles={{
                title: i18n.lithology,
                edit: i18n.editLithology,
                new: i18n.newLithology,
            }}
            headers={headers}
            dialogContent={LithologyDialogContent}
        />
    )
}

BoreholeLithologyTable.propTypes = {
    station: PropTypes.instanceOf(DtoInstallation),
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
}

export default BoreholeLithologyTable